import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import CSIRNet from './pages/CSIR-Net';
import CSIRNetDec from './pages/CSIR-Net-December';
import IITGateOneyear from './pages/IIT-Gate-One-Year';
import IITGateTwoyear from './pages/IIT-Gate-Two-Year';
import IITJamOneyear from './pages/IIT-Jam-One-Year';
import IITJamTwoyear from './pages/IIT-Jam-Two-Year';
import AssistantProfessorOneYear from './pages/Assistant-Professor-One-Year';
import AssistantProfessorTwoYear from './pages/Assistant-Professor-Two-Year';
import PGTChemistryOneYear from './pages/PGT-Chemistry-One-Year';
import PGTChemistryTwoYear from './pages/PGT-Chemistry-Two-Year';
import BSCChemistryOneYear from './pages/BSC-Chemistry-One-Year';
import BSCChemistryTwoYear from './pages/BSC-Chemistry-Two-Year';
import IITGATE from './pages/IIT-Gate';
import IITJam from './pages/IIT-Jam';
import PGTChemistry from './pages/PGTChemistry';
import Geochemist from './pages/Geochemist';
import PatentOfficer from './pages/PatentOfficer';
import BARCChemistry from './pages/BARCChemistry';
import PollutionControlBoard from './pages/PollutionControlBoard';
import Blog from './pages/Blog';
import Assistantprofessor from './pages/Assistantprofessor'
import Upgiclecturerrecruitment2025 from './pages/Up_gic_lecturer_recruitment2025';
import RPSCSchoollecturer2025 from './pages/RPSCSchoollecturer_recruitment2025';
import GATEExamination2026 from './pages/GATEExamination2026';
import BiharBPSCAESRecruitment2025 from './pages/Bihar-BPSCAES-Recruitment2025'
import TermsCondition from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import PrivacyPolicy from './pages/Privacypolicy';
import CSIRNetCourse from './pages/CSIR-Net-Course';
import IITGateCourse from './pages/IIT-Gate-Course';
import IITJamCourse from './pages/IIT-Jam-Course';
import TFIRCourse from './pages/TFIR-Course';
import CUETPGCourse from './pages/CUET-PGCourse';
import PGTChemistryCourse from './pages/PGT-Chemistry-Course';
import AssistantprofessorCourse from './pages/Assistant-professor-Course';
import BSCChemistryCourse from './pages/BSC-Chemistry-Course';
import TestSeries from './pages/Test-Series';
import PGTNVSKVS from './pages/PGT-NVS-KVS';
import PGTDSSSB from './pages/PGT-DSSSB';
import PGTHPSC from './pages/PGT-HPSC';
import PGTMPPSC from './pages/PGT-MPPSC';
import PGTRPSC from './pages/PGT-RPSC';
import PGTUPPSC from './pages/PGT-UPPSC';
import PGTPPSC from './pages/PGT-PPSC';
import PGTJkPSC from './pages/PGT-JkPSC';
import PGTCGPSC from './pages/PGT-CGPSC';
import PGTUKPSC from './pages/PGT-UKPSC';
import PGTHPPSC from './pages/PGT-HPPSC';
import PGTGPSC from './pages/PGT-GPSC';
import PGTBPSC from './pages/PGT-BPSC';
import PGTOPSC from './pages/PGT-OPSC';
import PGTMHPSC from './pages/PGT-MHPSC';
import PGTJANDkPSC from './pages/PGT-JkPSC';

import AssistantprofessorHPSC from './pages/Assistant-professorHPSC';
import AssistantprofessorMPPSC from './pages/Assistant-professorMPPSC';
import AssistantprofessorRPSC from './pages/Assistant-professorRPSC';
import AssistantprofessorUPPSC from './pages/Assistant-professorUPPSC';
import AssistantprofessorPPSC from './pages/Assistant-professorPPSC';
import AssistantprofessorJKPSC from './pages/Assistant-professorJKPSC';
import AssistantprofessorCGPSC from './pages/Assistant-professorCGPSC';
import AssistantprofessorUKPSC from './pages/Assistant-professorUKPSC';

import NotFound from "./pages/NotFound";

function App() {
  return (
    <Router>
      {/* Removed <Navbar /> from here */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/About' element={<About />} />
        <Route path='/CSIR-Net-Course' element={<CSIRNetCourse />} />
        <Route path='/IIT-Gate-Course' element={<IITGateCourse />} />
        <Route path='/IIT-Jam-Course' element={<IITJamCourse />} />
        <Route path='/TFIR-Course' element={<TFIRCourse />} />
        <Route path='/CUET-PG-Course' element={<CUETPGCourse />} />
        <Route path='/PGT-Chemistry-Course' element={<PGTChemistryCourse />} />
        <Route path='/Assistant-professor-Course' element={<AssistantprofessorCourse />} />
        <Route path='/BSC-Chemistry-Course' element={<BSCChemistryCourse />} />
        <Route path='/CSIR-Net' element={<CSIRNet />} />
        <Route path='/CSIR-Net-December' element={<CSIRNetDec />} />
        <Route path='/IIT-Gate-One-year' element={<IITGateOneyear />} />
        <Route path='/IIT-Gate-Two-Year' element={<IITGateTwoyear />} />
        <Route path='/IIT-Jam-One-Year' element={<IITJamOneyear />} />
        <Route path='/IIT-Jam-Two-Year' element={<IITJamTwoyear />} />
        <Route path='/Assistant-Professor-One-Year' element={<AssistantProfessorOneYear />} />
        <Route path='/Assistant-Professor-Two-Year' element={<AssistantProfessorTwoYear />} />
        <Route path='/PGT-Chemistry-One-Year' element={<PGTChemistryOneYear/>} />
        <Route path='/PGT-Chemistry-Two-Year' element={<PGTChemistryTwoYear/>} />
        <Route path='/BSC-Chemistry-One-Year' element={<BSCChemistryOneYear/>} />
        <Route path='/BSC-Chemistry-Two-Year' element={<BSCChemistryTwoYear/>} />
        <Route path='/IIT-GATE' element={<IITGATE />} />
        <Route path='/IIT-Jam' element={<IITJam />} />
        <Route path='/Assistant-professor' element={<Assistantprofessor />} />
        <Route path='/PGT-Chemistry' element={<PGTChemistry />} />
        <Route path='/Geochemist' element={<Geochemist />} />
        <Route path='/Patent-Officer' element={<PatentOfficer />} />
        <Route path='/BARC-Chemistry' element={<BARCChemistry />} />
        <Route path='/Pollution-Control-Board' element={<PollutionControlBoard />} />
        <Route path='/Test-Series' element={<TestSeries />} />
        <Route path='/Blog' element={<Blog />} />
        <Route path='/Contact' element={<Contact />} />
        <Route path='/Terms-condition' element={<TermsCondition />} />
        <Route path='/Refund-policy' element={<RefundPolicy />} />
        <Route path='/Privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/Upgiclecturerrecruitment2025' element={<Upgiclecturerrecruitment2025 />} />
        <Route path='/RPSCSchoollecturer2025' element={<RPSCSchoollecturer2025 />} />
        <Route path='/GATEExamination2026' element={<GATEExamination2026 />} />
        <Route path='/BiharBPSCAESRecruitment2025' element={<BiharBPSCAESRecruitment2025 /> } />

        <Route path='/PGTNVSKVS' element={<PGTNVSKVS /> } />
        <Route path='/PGTDSSSB' element={<PGTDSSSB /> } />
        <Route path='/PGTHPSC' element={<PGTHPSC /> } />
        <Route path='/PGTMPPSC' element={<PGTMPPSC /> } />
        <Route path='/PGTRPSC' element={<PGTRPSC /> } />
        <Route path='/PGTUPPSC' element={<PGTUPPSC /> } />
        <Route path='/PGTPPSC' element={<PGTPPSC /> } />
        <Route path='/PGTJkPSC' element={<PGTJkPSC /> } />
        <Route path='/PGTCGPSC' element={<PGTCGPSC /> } />
        <Route path='/PGTUKPSC' element={<PGTUKPSC /> } />
        <Route path='/PGTJkPSC' element={<PGTJkPSC /> } />
        <Route path='/PGTHPPSC' element={<PGTHPPSC /> } />
        <Route path='/PGTGPSC' element={<PGTGPSC /> } />
        <Route path='/PGTBPSC' element={<PGTBPSC /> } />
        <Route path='/PGTOPSC' element={<PGTOPSC /> } />
        <Route path='/PGTMHPSC' element={<PGTMHPSC /> } />
        <Route path='/PGTJANDkPSC' element={<PGTJANDkPSC />} /> 

        <Route path='/AssistantprofessorHPSC' element={<AssistantprofessorHPSC /> } />
        <Route path='/AssistantprofessorMPPSC' element={<AssistantprofessorMPPSC /> } />
        <Route path='/AssistantprofessorRPSC' element={<AssistantprofessorRPSC /> } />
        <Route path='/AssistantprofessorUPPSC' element={<AssistantprofessorUPPSC /> } />
        <Route path='/AssistantprofessorPPSC' element={<AssistantprofessorPPSC /> } />
        <Route path='/AssistantprofessorJKPSC' element={<AssistantprofessorJKPSC /> } />
        <Route path='/AssistantprofessorCGPSC' element={<AssistantprofessorCGPSC /> } />
        <Route path='/AssistantprofessorUKPSC' element={<AssistantprofessorUKPSC /> } />


        <Route path="*" element={<NotFound />} />
        
      </Routes>
    </Router>
  );
}


export default App;
